import { render, staticRenderFns } from "./QuizTrueFalseScreenForm.vue?vue&type=template&id=67769404&"
import script from "./QuizTrueFalseScreenForm.vue?vue&type=script&lang=ts&"
export * from "./QuizTrueFalseScreenForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports